import React  from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import Header from './Header.jsx';
import { Callback } from "./auth/CallBack.jsx";
import { Auth0ProviderWithNavigate } from "./auth/Auth0ProviderWithNavigate.jsx";
import { ProtectedRoute } from "./auth/ProtectedRoute.jsx";
import Dashboard from './Dashboard.jsx';
import ReportsPage from './ReportsPage.jsx';
import ReportDashboardPage from './ReportDashboardPage.jsx';


const Main = () => {
    const protectedDefaultRoute = (<Route
      path="/"
      element={<ProtectedRoute component={Dashboard} />}
      //  element={<Dashboard/>}
    />);

    const protectedGroupRoute = (<Route
      path="/group/:groupName"
       element={<ProtectedRoute component={Dashboard} />}
        //  element={<Dashboard/>}
    />);

 const callbackRoute = (<Route
     path="/callback"
     element={<Callback />}
   />
   );

   const reportsRoute = (<Route
     path="/reports"
     element={<ProtectedRoute component={ReportsPage} />}
   />
   );

   const reportDashboardRoute = (<Route
     path="/reportDashboard"
     element={<ProtectedRoute component={ReportDashboardPage} />}
   />
   );
 
    const mainContent = 
   (
     <HashRouter>
       <Auth0ProviderWithNavigate>
         <Header/>
         {/* <Dashboard /> */}
             <Routes>
                {protectedDefaultRoute}
                {protectedGroupRoute}
               {callbackRoute}
               {reportsRoute}
               {reportDashboardRoute}
             </Routes>
       </Auth0ProviderWithNavigate>
     </HashRouter>
   );
   
   return (
       <div>
         {mainContent}
       </div>
   );
 };
 
 export default Main
 